import { sharedLocalStorage } from "~/features/storage/local.client";

export const syncEmployeeId = async (employeeId: string | undefined) => {
  if (!employeeId) {
    return await sharedLocalStorage.employeeId.remove();
  }

  const existingEmployeeId = await sharedLocalStorage.employeeId.get();
  if (existingEmployeeId !== employeeId) {
    await sharedLocalStorage.employeeId.set(employeeId);
  }
};
